<template>
  <div class="home">
    <el-container class="home-center">
      <el-header height="120px">
        <div class="header">
          <div class="header-name">
            <div>{{ i18nCompetitionName }}</div>
            <div class="register-time">
              <i class="el-icon-time time-icon " ></i>
              {{ $t('manager.registerTime') }}: {{ competitionInfo.fakeStartTime }} - {{ competitionInfo.fakeEndTime }}
            </div>
          </div>
          <div class="header-logo">
            <div class="logo-img" v-if="competitionInfo.logo1"><img :src="define.previewNginxUrl + competitionInfo.logo1"/></div>
            <div class="logo-img" v-if="competitionInfo.logo2"><img :src="define.previewNginxUrl + competitionInfo.logo2"/></div>
            <div class="logo-img" v-if="competitionInfo.logo3"><img :src="define.previewNginxUrl + competitionInfo.logo3"/></div>
            <div class="header-team">
              <div class="team-info">
                <div class="team-header" v-if="username">
                  <i class="el-icon-user team-icon"></i>
                  <div class="username">{{ username }}</div>
                </div>
                <div class="header-button">
                  <LangSwitcher />
                  <div><el-button type="text" @click="logout()"><i class="el-icon-switch-button switch-button" />{{ $t('manager.logout') }}</el-button></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-header>
      <el-container>
        <el-main>
          <div class="table-center">
            <div class="search-row">
              <el-input class="search-input" v-model="params.teamName" :placeholder="$t('manager.placeholderTeamName')" clearable></el-input>
              <el-input class="search-input" v-model="params.mobile" :placeholder="$t('manager.placeholderContactPhone')" clearable></el-input>
              <el-select v-model="params.status" :placeholder="$t('manager.placeholderStatus')" clearable filterable>
                <el-option v-for="item in statusList" :key="item.id" :label="localeValue(item, submitStatusNameKey)" :value="item.id">
                </el-option>
              </el-select>
              <el-button type="primary" @click="findTeamList">{{ $t('common.search') }}</el-button>
              <el-button @click="emptyParams">{{ $t('common.reset') }}</el-button>
              <el-button type="primary" icon="el-icon-download" @click="handleExportTeam">{{ $t('manager.exportTeam') }}</el-button>
              <el-button type="primary" icon="el-icon-download" @click="handleExportAthlete">{{ $t('manager.exportAthlete') }}</el-button>
              <el-button type="primary" icon="el-icon-download" @click="handleExportOfficial">{{ $t('manager.exportOfficial') }}</el-button>
            </div>
            <div class="table-body" v-loading="!formConfigLoaded">
              <el-table v-if="formConfigLoaded" :data="teamList" :border="true" height="100%">
              <el-table-column type="index" :label="$t('common.serialNo')" width="50" :fixed="true"></el-table-column>
              <el-table-column v-if="isListFieldVisible('teamForm', 'teamNameJson')" prop="teamName" :label="$t('manager.teamName')" min-width="150" :fixed="true"></el-table-column>
              <el-table-column v-if="isListFieldVisible('teamForm', 'realNameJson')" prop="realName" :label="$t('manager.contactName')" min-width="120"></el-table-column>
              <el-table-column v-if="isListFieldVisible('teamForm', 'mobileJson')" prop="mobile" :label="$t('manager.contactPhone')" min-width="130"></el-table-column>
              <el-table-column v-if="isListFieldVisible('teamForm', 'emailJson')" prop="email" :label="$t('manager.contactEmail')" min-width="120"></el-table-column>
              <el-table-column v-if="isListFieldVisible('teamForm', 'memberUnitJson')" prop="" :label="$t('manager.memberUnitName')" min-width="140">
                <template slot-scope="scope">
                  {{localeValue(scope.row, competitionMemberUnitNameKey)}}
                </template>
              </el-table-column>
              <el-table-column prop="athleteNum" :label="$t('manager.athleteCount')" min-width="110" sortable>
                <template slot-scope="scope">
                  {{scope.row.athleteNum}}{{$t('common.people')}}
                </template>
              </el-table-column>
              <el-table-column prop="reportFile" :label="$t('common.registrationForm')" min-width="150">
                <template slot-scope="scope">
                  <div><el-button @click="handleReportFile(scope.row.reportFile)" type="text" v-if="scope.row.reportFile">{{ $t('manager.downloadStampedForm') }}</el-button></div>
                  <div><el-button @click="handleReportFile(scope.row.responsibilityFile)" type="text" v-if="scope.row.responsibilityFile">{{ $t('manager.downloadLiability') }}</el-button></div>
                </template>
              </el-table-column>
              <el-table-column prop="status" :label="$t('manager.submitStatus')" min-width="120" sortable>
                <template slot-scope="scope">
                  <span class="status-badge" :class="scope.row.status === 1 ? 'status-not-submitted' : 'status-submitted'" v-if="scope.row.status === 1">{{ $t('manager.notSubmitted') }}</span>
                  <span class="status-badge" :class="scope.row.status === 2 ? 'status-submitted' : 'status-not-submitted'" v-if="scope.row.status === 2">{{ $t('manager.submitted') }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="submitTime" :label="$t('manager.submitTime')" min-width="120" sortable></el-table-column>
              <el-table-column fixed="right" :label="$t('common.operation')" width="160" align="left">
                <template slot-scope="scope">
                  <el-button @click="handleDetails(scope.row.userId)" type="text">{{ $t('common.view') }}</el-button>
                  <el-button @click="handleSubmit(scope.row.id)" type="text" v-if="scope.row.status === 1">{{ $t('manager.submit') }}</el-button>
                  <el-button @click="handleCancelSubmit(scope.row.id)" style="color:#F56C6C;" type="text" v-if="scope.row.status === 2">{{ $t('manager.reject') }}</el-button>
                  <!-- 更多操作：下载 -->
                  <el-dropdown hide-on-click style="margin-left: 12px">
                    <el-button type="text" size="x">{{ $t('common.moreBtn') }}<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="handleDownload(scope.row.userId)">{{ $t('projectSum.downloadForm') }}</el-dropdown-item>
                      <el-dropdown-item @click.native="handleViewAccount(scope.row.userId)">{{ $t('manager.viewAccount') }}</el-dropdown-item>
                      <el-dropdown-item @click.native="handleDelTeam(scope.row.id)" style="color:#F56C6C;">{{ $t('manager.delTeam') }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
            </div>
          </div>
        </el-main>
      </el-container>
      <Footer/>
    </el-container>
    <!--  查看  -->
    <el-dialog :title="$t('manager.teamDetail')" :visible.sync="formVisible" width="1200px" lock-scroll :close-on-click-modal="false">
      <div class="table-info">
        <el-row class="row-border-1">
          <el-col :span="24" class="padding10">
            <div class="text-center font-weight">
              {{localeValue(competitionSumInfo, competitionNameKey)}}-{{teamInfoVo.teamName}}{{$t('projectSum.registrationForm')}}
            </div>
          </el-col>
        </el-row>
        <!--队伍信息-->
        <el-row class="row-border-1" v-if="teamColumns.length > 0">
          <el-col :span="24" class="padding10 bg-eeecec">
            <div class="text-center font-weight">{{ $t('manager.teamInfo') }}</div>
          </el-col>
        </el-row>
        <el-row class="row-border-1" v-if="teamColumns.length > 0">
          <el-col v-for="(col, index) in teamColumns" :key="col.key" :span="col.span"
                  :class="index === 0 ? 'padding10' : 'cell-border-f padding10'">
            <div class="text-center font-weight">{{ col.label }}</div>
          </el-col>
        </el-row>
        <el-row class="row-border-1" v-if="teamColumns.length > 0">
          <el-col v-for="(col, index) in teamColumns" :key="col.key + '-value'" :span="col.span"
                  :class="index === 0 ? 'padding10' : 'cell-border-f padding10'">
            <div class="text-center word-break">{{ localeValue(teamInfoVo, col.prop) }}</div>
          </el-col>
        </el-row>
        <!--运动员信息-->
        <el-row class="row-border-1" v-if="athleteColumns.length > 0">
          <el-col :span="24" class="padding10 bg-eeecec">
            <div class="text-center font-weight">{{ $t('manager.athleteInfo') }}</div>
          </el-col>
        </el-row>
        <el-row class="row-border-1" v-if="athleteColumns.length > 0">
          <el-col v-for="(col, index) in athleteColumns" :key="col.key" :span="col.span"
                  :class="index === 0 ? 'padding10' : 'cell-border-f padding10'">
            <div class="text-center font-weight">{{ col.label }}</div>
          </el-col>
        </el-row>
        <div v-for="athlete in competitionSumInfo.athleteList" :key="athlete.id">
          <el-row class="row-border-1">
            <el-col v-for="(col, index) in athleteColumns" :key="col.key" :span="col.span"
                    :class="index === 0 ? '' : 'cell-border-f'">
              <div class="text-center cell-image">
                <el-image v-if="col.type === 'image'"
                          style="width: auto; height: 40px"
                          :src="define.previewNginxUrl + athlete[col.prop]"
                          :preview-src-list="[define.previewNginxUrl + athlete[col.prop]]">
                </el-image>
                <span v-else>{{ formatCellValue(athlete, col) }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--随队官员-->
        <el-row class="row-border-1" v-if="personColumns.length > 0">
          <el-col :span="24" class="padding10 bg-eeecec">
            <div class="text-center font-weight">{{ $t('manager.officialInfo') }}</div>
          </el-col>
        </el-row>
        <el-row class="row-border-1" v-if="personColumns.length > 0">
          <el-col v-for="(col, index) in personColumns" :key="col.key" :span="col.span"
                  :class="index === 0 ? 'padding10' : 'cell-border-f padding10'">
            <div class="text-center font-weight">{{ col.label }}</div>
          </el-col>
        </el-row>
        <div v-for="person in competitionSumInfo.personList" :key="person.id">
          <el-row class="row-border-1">
            <el-col v-for="(col, index) in personColumns" :key="col.key" :span="col.span"
                    :class="index === 0 ? '' : 'cell-border-f'">
              <div class="text-center cell-image">
                <el-image v-if="col.type === 'image'"
                          style="width: auto; height: 40px"
                          :src="define.previewNginxUrl + person[col.prop]"
                          :preview-src-list="[define.previewNginxUrl + person[col.prop]]">
                </el-image>
                <span v-else>{{ formatCellValue(person, col) }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--个人项目-->
        <template v-if="showProjectType('1')">
          <el-row class="row-border-1">
            <el-col :span="24" class="padding10 bg-eeecec">
              <div class="text-center font-weight">{{ $t('common.individualProject') }}</div>
            </el-col>
          </el-row>
          <div v-for="(personProjects, key) in competitionSumInfo.personProjectList" :key="'personProject-' + key">
            <el-row class="row-border-1">
              <el-col :span="5" class="padding10">
                <div class="text-center">{{localeValue(personProjects, projectNameKey)}}</div>
              </el-col>
              <el-col :span="19" class="cell-border-f padding10">
                <div class="">
                  <span v-for="(personProject, index) in personProjects.teamAthleteList" :key="personProject.id">
                    <span v-if="index === 0">{{localeValue(personProject, competitionAthleteNameKey)}}</span>
                    <span v-else>、{{localeValue(personProject, competitionAthleteNameKey)}}</span>
                   <span v-if="personProject.description">（{{ remarkLabel }}：{{personProject.description}}）</span>
                  </span>
                </div>
              </el-col>
            </el-row>
          </div>
        </template>
        <!--集体项目-->
        <template v-if="showProjectType('2')">
          <el-row class="row-border-1">
            <el-col :span="24" class="padding10 bg-eeecec">
              <div class="text-center font-weight">{{ $t('common.groupProject') }}</div>
            </el-col>
          </el-row>
          <div v-for="(teamProjects, key) in competitionSumInfo.teamProjectList" :key="'teamProject-' + key">
            <el-row class="row-border-1">
              <el-col :span="5" class="padding10">
                <div class="text-center">{{localeValue(teamProjects, projectNameKey)}}</div>
              </el-col>
              <el-col :span="19" class="cell-border-f padding10">
                <div class="">
                  <span v-for="(teamProject, index) in teamProjects.teamAthleteList" :key="teamProject.id">
                    <span v-if="index === 0">{{localeValue(teamProject, competitionAthleteNameKey)}}{{localeValue(teamProject, itemPositionNameKey) ? '（' + $t('common.position') + '：' + localeValue(teamProject, itemPositionNameKey) + '）' : ''}}{{teamProject.substitution === 1 ? $t('common.substitute') : ''}}</span>
                    <span v-else>、{{localeValue(teamProject, competitionAthleteNameKey)}}{{localeValue(teamProject, itemPositionNameKey) ? '（' + $t('common.position') + '：' + localeValue(teamProject, itemPositionNameKey) + '）' : ''}}{{teamProject.substitution === 1 ? $t('common.substitute') : ''}}</span>
                  </span>
                  <span v-if="teamProjects.teamAthleteList[0] && teamProjects.teamAthleteList[0].description">（{{ remarkLabel }}：{{ teamProjects.teamAthleteList[0].description}}）</span>
                </div>
              </el-col>
            </el-row>
          </div>
        </template>
        <!--对练项目-->
        <template v-if="showProjectType('3')">
          <el-row class="row-border-1">
            <el-col :span="24" class="padding10 bg-eeecec">
              <div class="text-center font-weight">{{ $t('common.pairTrainingProject') }}</div>
            </el-col>
          </el-row>
          <div v-for="(trainProjects, key) in competitionSumInfo.trainProjectList" :key="'trainProject-' + key">
            <el-row class="row-border-1">
              <el-col :span="5" class="padding10">
                <div class="text-center">{{localeValue(trainProjects, projectNameKey)}}</div>
              </el-col>
              <el-col :span="19" class="cell-border-f padding10">
                <div class="">
                  <div v-for="(trainValue, trainKey, index) in trainProjects.trainAthleteList" :key="trainKey">
                    {{index+1}}、
                    <span v-for="(trainItem, index) in trainValue" :key="trainItem.id" style="width: 100%">
                      <span v-if="index === 0">{{localeValue(trainItem, competitionAthleteNameKey)}}</span>
                      <span v-else>、{{localeValue(trainItem, competitionAthleteNameKey)}}</span>
                      <span v-if="trainItem.practice === 1">{{ $t('common.trainingPartner') }}</span>
                    </span>
                    <span v-if="trainValue[0] && trainValue[0].description">（{{ remarkLabel }}：{{trainValue[0].description }}）</span>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </template>
        <!--统计信息-->
        <el-row class="row-border-1">
          <el-col :span="24" class="padding10 bg-eeecec">
            <div class="text-center font-weight">{{ $t('common.statistics') }}</div>
          </el-col>
        </el-row>
        <el-row class="row-border-1">
          <el-col :span="4" class="padding10">
            <div class="text-center font-weight">{{ $t('common.totalPeople') }}</div>
          </el-col>
          <el-col :span="4" class="cell-border-f padding10">
            <div class="text-center font-weight">{{ $t('common.male') }}</div>
          </el-col>
          <el-col :span="4" class="cell-border-f padding10">
            <div class="text-center font-weight">{{ $t('common.female') }}</div>
          </el-col>
          <el-col :span="4" class="cell-border-f padding10">
            <div class="text-center font-weight">{{ $t('common.athlete') }}</div>
          </el-col>
          <el-col :span="4" class="cell-border-f padding10">
            <div class="text-center font-weight">{{ $t('common.maleAthlete') }}</div>
          </el-col>
          <el-col :span="4" class="cell-border-f padding10">
            <div class="text-center font-weight">{{ $t('common.femaleAthlete') }}</div>
          </el-col>
        </el-row>
        <el-row class="row-border-1">
          <el-col :span="4" class="cell-border-b padding10">
            <div class="text-center">{{personStaVo.sumNum}} {{$t('common.people')}}</div>
          </el-col>
          <el-col :span="4" class="cell-border-fb padding10">
            <div class="text-center">{{personStaVo.maleNum}} {{$t('common.people')}}</div>
          </el-col>
          <el-col :span="4" class="cell-border-fb padding10">
            <div class="text-center">{{personStaVo.femaleNum}} {{$t('common.people')}}</div>
          </el-col>
          <el-col :span="4" class="cell-border-fb padding10">
            <div class="text-center">{{personStaVo.athleteNum}} {{$t('common.people')}}</div>
          </el-col>
          <el-col :span="4" class="cell-border-fb padding10">
            <div class="text-center">{{personStaVo.maleAthleteNum}} {{$t('common.people')}}</div>
          </el-col>
          <el-col :span="4" class="cell-border-fb padding10">
            <div class="text-center">{{personStaVo.femaleAthleteNum}} {{$t('common.people')}}</div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <!--  查看账号密码  -->
    <el-dialog :title="$t('manager.viewAccount')" :visible.sync="accountVisible" width="420px" lock-scroll :close-on-click-modal="false">
      <el-form label-width="80px">
        <el-form-item :label="$t('manager.account')">
          <span>{{ accountInfo.account }}</span>
        </el-form-item>
        <el-form-item :label="$t('manager.password')">
          <span>{{ accountInfo.password }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="accountVisible = false">{{ $t('common.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getCompetitionInfo, competitionSumInfo} from "@/api/competition";
import {getCompetitionFormConfigInfo} from "@/api/competitionFormConfig";
import {getTeamList, getTeamExport, cancelSubmitTeamInfo, managerSubmitTeamInfo, managerDelTeamInfo} from "@/api/team";
import {getAthleteExport} from "@/api/athlete";
import {getPersonExport} from "@/api/person";
import { logout as logoutApi, appCurrentUser, getUserAccount } from "@/api/user";
import Footer from "@/components/Footer.vue";
import LangSwitcher from "@/components/LangSwitcher.vue";
export default {
  name: "manager",
  components: { Footer, LangSwitcher },
  computed: {
    // 备注标题（报项表单配置，留空默认备注）
    remarkLabel() {
      const remarkLabel = (this.competitionFormConfigInfo.projectForm || {}).remarkLabel;
      return remarkLabel || this.$t('common.comment');
    },
    // 赛事名称中英文
    i18nCompetitionName() {
      return this.$i18n.locale === 'zh-CN' ? this.competitionInfo.nameCh : (this.competitionInfo.nameEn || this.competitionInfo.nameCh);
    },
    // 提交状态中英文
    submitStatusNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'nameCh' : 'nameEn';
    },
    // 赛事会员单位中英文
    competitionMemberUnitNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'memberUnitNameCh' : 'memberUnitNameEn';
    },
    // 地区名称中英文
    competitionRegionNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'regionNameCh' : 'regionNameEn';
    },
    // 赛事名称中英文
    competitionNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'nameCh' : 'nameEn';
    },
    // 赛事组别名称中英文
    competitionGroupNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'groupNameCh' : 'groupNameEn';
    },
    // 赛事小项名称中英文
    competitionItemNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'itemNameCh' : 'itemNameEn';
    },
    // 赛事运动员姓名中英文
    competitionAthleteNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'athleteRealNameCh' : 'athleteRealNameEn';
    },
    // 集体项目运动员职位名称中英文
    itemPositionNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'itemPositionNameCh' : 'itemPositionNameEn';
    },
    // 项目名称中英文
    projectNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'nameCh' : 'nameEn';
    },
    // 赛事职能名称中英文
    competitionFunctionNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'functionNameCh' : 'functionNameEn';
    },
    // 显示项目类型区块（1=个人项目 2=集体项目 3=对练项目）
    showProjectType() {
      return (fieldType) => {
        const competitionForm = this.competitionFormConfigInfo.competitionForm;
        if (!competitionForm) return false;
        const fieldConfig = competitionForm.projectTypeJson;
        return fieldConfig && fieldConfig.checkedOptions && fieldConfig.checkedOptions.includes(fieldType);
      };
    },
    // 运动员字段标签
    labelAthleteField() {
      return (fieldName) => {
        const fieldConfig = (this.competitionFormConfigInfo.athleteForm || {})[fieldName];
        return fieldConfig && fieldConfig.label;
      };
    },
    // 随队官员字段标签
    labelPersonField() {
      return (fieldName) => {
        const fieldConfig = (this.competitionFormConfigInfo.personForm || {})[fieldName];
        return fieldConfig && fieldConfig.label;
      };
    },
    // 代表队信息动态列（显示/隐藏、汇总表宽度取自队伍表单配置）
    teamColumns() {
      const defs = [
        {key: 'realNameJson', prop: 'realName', label: this.$t('teamInfo.contactName')},
        {key: 'mobileJson', prop: 'mobile', label: this.$t('common.contactPhone')},
        {key: 'emailJson', prop: 'email', label: this.$t('common.contactEmail')},
        {key: 'memberUnitJson', prop: this.competitionMemberUnitNameKey, label: this.$t('teamInfo.memberUnit')},
        {key: 'regionJson', prop: this.competitionRegionNameKey, label: this.$t('teamInfo.region')},
      ];
      return this.summaryColumns('teamForm', defs);
    },
    // 运动员信息动态列（显示/隐藏、汇总表宽度取自运动员表单配置）
    athleteColumns() {
      const defs = [
        {key: 'realNameChJson', prop: 'realNameCh', label: this.labelAthleteField('realNameChJson')},
        {key: 'realNameEnJson', prop: 'realNameEn', label: this.$t('athleteInfo.realNameEn')},
        {key: 'familyNameChJson', prop: 'familyNameCh', label: this.$t('athleteInfo.surnameCh')},
        {key: 'familyNameEnJson', prop: 'familyNameEn', label: this.$t('athleteInfo.surnameEn')},
        {key: 'givenNameChJson', prop: 'givenNameCh', label: this.$t('athleteInfo.givenNameCh')},
        {key: 'givenNameEnJson', prop: 'givenNameEn', label: this.$t('athleteInfo.givenNameEn')},
        {key: 'certificateTypeJson', prop: 'certificateType', label: this.$t('common.certificateType'), type: 'certificateType'},
        {key: 'certificateNumberJson', prop: 'certificateNumber', label: this.$t('common.certificateNumber')},
        {key: 'genderJson', prop: 'gender', label: this.$t('common.gender'), type: 'gender'},
        {key: 'ageJson', prop: 'age', label: this.$t('common.age')},
        {key: 'birthdayJson', prop: 'birthday', label: this.$t('common.birthDate')},
        {key: 'groupJson', prop: this.competitionGroupNameKey, label: this.$t('common.group')},
        {key: 'headIconJson', prop: 'headIcon', label: this.$t('common.headPhoto'), type: 'image'},
        {key: 'certificateFrontalPhotoJson', prop: 'certificateFrontalPhoto', label: this.$t('common.certificateFrontPhoto'), type: 'image'},
        {key: 'certificateReversePhotoJson', prop: 'certificateReversePhoto', label: this.$t('common.certificateBackPhoto'), type: 'image'},
        {key: 'mobileJson', prop: 'mobile', label: this.$t('common.contactPhone')},
        {key: 'emailJson', prop: 'email', label: this.$t('common.contactEmail')},
        {key: 'customText1Json', prop: 'customText1', label: this.labelAthleteField('customText1Json')},
        {key: 'customText2Json', prop: 'customText2', label: this.labelAthleteField('customText2Json')},
        {key: 'customText3Json', prop: 'customText3', label: this.labelAthleteField('customText3Json')},
        {key: 'customFile1Json', prop: 'customFile1', label: this.labelAthleteField('customFile1Json'), type: 'image'},
        {key: 'customFile2Json', prop: 'customFile2', label: this.labelAthleteField('customFile2Json'), type: 'image'},
        {key: 'customFile3Json', prop: 'customFile3', label: this.labelAthleteField('customFile3Json'), type: 'image'},
      ];
      return this.summaryColumns('athleteForm', defs);
    },
    // 随队官员信息动态列（显示/隐藏、汇总表宽度取自随队官员表单配置）
    personColumns() {
      const defs = [
        {key: 'realNameChJson', prop: 'realNameCh', label: this.labelPersonField('realNameChJson')},
        {key: 'realNameEnJson', prop: 'realNameEn', label: this.$t('personInfo.realNameEn')},
        {key: 'familyNameChJson', prop: 'familyNameCh', label: this.$t('personInfo.surnameCh')},
        {key: 'familyNameEnJson', prop: 'familyNameEn', label: this.$t('personInfo.surnameEn')},
        {key: 'givenNameChJson', prop: 'givenNameCh', label: this.$t('personInfo.givenNameCh')},
        {key: 'givenNameEnJson', prop: 'givenNameEn', label: this.$t('personInfo.givenNameEn')},
        {key: 'certificateTypeJson', prop: 'certificateType', label: this.$t('common.certificateType'), type: 'certificateType'},
        {key: 'certificateNumberJson', prop: 'certificateNumber', label: this.$t('common.certificateNumber')},
        {key: 'genderJson', prop: 'gender', label: this.$t('common.gender'), type: 'gender'},
        {key: 'ageJson', prop: 'age', label: this.$t('common.age')},
        {key: 'birthdayJson', prop: 'birthday', label: this.$t('common.birthDate')},
        {key: 'groupJson', prop: this.competitionGroupNameKey, label: this.$t('common.group')},
        {key: 'itemJson', prop: this.competitionItemNameKey, label: this.$t('common.item')},
        {key: 'headIconJson', prop: 'headIcon', label: this.$t('common.headPhoto'), type: 'image'},
        {key: 'certificateFrontalPhotoJson', prop: 'certificateFrontalPhoto', label: this.$t('common.certificateFrontPhoto'), type: 'image'},
        {key: 'certificateReversePhotoJson', prop: 'certificateReversePhoto', label: this.$t('common.certificateBackPhoto'), type: 'image'},
        {key: 'mobileJson', prop: 'mobile', label: this.$t('common.contactPhone')},
        {key: 'emailJson', prop: 'email', label: this.$t('common.contactEmail')},
        {key: 'functionJson', prop: this.competitionFunctionNameKey, label: this.$t('common.function')},
        {key: 'customText1Json', prop: 'customText1', label: this.labelPersonField('customText1Json')},
        {key: 'customText2Json', prop: 'customText2', label: this.labelPersonField('customText2Json')},
        {key: 'customText3Json', prop: 'customText3', label: this.labelPersonField('customText3Json')},
        {key: 'customFile1Json', prop: 'customFile1', label: this.labelPersonField('customFile1Json'), type: 'image'},
        {key: 'customFile2Json', prop: 'customFile2', label: this.labelPersonField('customFile2Json'), type: 'image'},
        {key: 'customFile3Json', prop: 'customFile3', label: this.labelPersonField('customFile3Json'), type: 'image'},
      ];
      return this.summaryColumns('personForm', defs);
    },
  },
  data() {
    return {
      // 当前用户
      username: '',
      // 筛选
      params: {
        teamName: '',
        mobile: '',
        status: ''
      },
      // 赛事ID
      competitionId: '',
      // 赛事信息
      competitionInfo: {},
      // 赛事表单配置信息
      competitionFormConfigInfo: {},
      // 赛事表单配置是否已加载（加载完成前不渲染配置列，避免列先显示后消失）
      formConfigLoaded: false,
      // 查看账号密码弹窗
      accountVisible: false,
      // 账号密码信息
      accountInfo: {
        account: '',
        password: ''
      },
      // 性别
      statusList: [
        {id: 1, nameCh: '未提交', nameEn: 'Not Submitted'},
        {id: 2, nameCh: '已提交', nameEn: 'Submitted'},
      ],
      // 代表队列表
      teamList: [],
      // 查看表单
      formVisible: false,
      // 汇总信息
      competitionSumInfo: {},
      // 代表队信息
      teamInfoVo: {},
      // 汇总统计
      personStaVo: {},
    };
  },
  created() {
    let id = this.$route.query.id;
    if (!id) {
      this.$router.push({ path: "/index" });
    } else {
      this.competitionId = id;
    }
  },
  mounted() {
    let isRegisterAdmin = Number(localStorage.getItem("isRegisterAdmin"));
    if (isRegisterAdmin === 0) {
      this.$router.push({ path: "/index" });
    } else {
      if (!localStorage.getItem("token")) {
        this.$router.push({path: "/login?id=" + this.competitionId});
      } else {
        this.findCurrentUser();
        this.findCompetitionInfo();
        // 先加载表单配置再加载代表队列表，避免配置列先显示后消失
        this.findCompetitionFormConfigInfo().then(() => {
          this.findTeamList();
        });
      }
    }
  },
  destroyed() {

  },
  methods: {
    // 获取当前登录用户
    findCurrentUser() {
      const cached = localStorage.getItem('username');
      if (cached) this.username = cached;
      appCurrentUser().then((res) => {
        if (res.code === 200) {
          this.username = res.data.account;
          localStorage.setItem('username', res.data.account);
        }
      });
    },
    // 获取赛事信息
    findCompetitionInfo(){
      getCompetitionInfo(this.competitionId).then((res) => {
        this.competitionInfo = res.data;
      });
    },
    // 获取赛事表单配置信息
    findCompetitionFormConfigInfo(){
      // 无论成功失败都结束加载阶段；失败时按未配置（全部列显示）降级
      return getCompetitionFormConfigInfo(this.competitionId).then((res) => {
        this.competitionFormConfigInfo = res.data || {};
      }).finally(() => {
        this.formConfigLoaded = true;
      });
    },
    // 导出代表队信息
    handleExportTeam(){
      getTeamExport({competitionId: this.competitionId}).then((res) => {
        this.saveExcel(res, this.i18nCompetitionName + '_' + this.$t('manager.exportTeam'));
      });
    },
    // 导出运动员信息
    handleExportAthlete(){
      getAthleteExport({competitionId: this.competitionId}).then((res) => {
        this.saveExcel(res, this.i18nCompetitionName + '_' + this.$t('manager.exportAthlete'));
      });
    },
    // 导出随队官员信息
    handleExportOfficial(){
      getPersonExport({competitionId: this.competitionId}).then((res) => {
        this.saveExcel(res, this.i18nCompetitionName + '_' + this.$t('manager.exportOfficial'));
      });
    },
    // 保存Excel文件
    saveExcel(data, fileName) {
      if (!data || data.type === 'application/json') {
        this.$message.error('导出失败，请重试');
        return;
      }
      const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName + '.xlsx';
      link.click();
      URL.revokeObjectURL(link.href);
    },
    // 根据表单配置生成汇总表动态列（isShow控制显示，span为汇总表宽度）
    summaryColumns(formName, defs) {
      const formConfig = this.competitionFormConfigInfo[formName] || {};
      const columns = [];
      defs.forEach(def => {
        const fieldConfig = formConfig[def.key];
        if (fieldConfig && fieldConfig.isShow === 1) {
          columns.push({
            key: def.key,
            prop: def.prop,
            label: def.label,
            type: def.type || 'text',
            span: fieldConfig.span && fieldConfig.span > 0 ? fieldConfig.span : 4, // span未配置或为0时按1/6宽度兜底，避免列被压没
          });
        }
      });
      return columns;
    },
    // 列表字段是否显示（按表单配置isShow控制隐藏，未配置时默认显示）
    isListFieldVisible(formName, key) {
      // 表单配置未加载完成前不渲染配置列
      if (!this.formConfigLoaded) {
        return false;
      }
      const formConfig = this.competitionFormConfigInfo[formName] || {};
      const fieldConfig = formConfig[key];
      return !fieldConfig || fieldConfig.isShow !== 0;
    },
    // 汇总表单元格文本
    formatCellValue(row, col) {
      const value = this.localeValue(row, col.prop);
      if (col.type === 'gender') {
        return value === 1 ? this.$t('common.male') : this.$t('common.female');
      }
      if (col.type === 'certificateType') {
        return this.certificateTypeText(value);
      }
      return value === null || value === undefined ? '' : value;
    },
    // 证件类型文本
    certificateTypeText(value) {
      const labelMap = {
        1: 'common.idCard',
        2: 'common.drivingLicense',
        3: 'common.passport',
        4: 'common.militaryCard',
        5: 'common.hkMacauId',
        6: 'common.taiwanPermit',
        7: 'common.other'
      };
      return labelMap[value] ? this.$t(labelMap[value]) : '';
    },
    // 代表队列表
    findTeamList() {
      let params = {
        competitionId: this.competitionId,
        teamName: this.params.teamName,
        mobile: this.params.mobile,
        status: this.params.status
      }
      getTeamList(params).then((res) => {
        if (res.code === 200) {
          this.teamList = res.data.list;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 盖章报名表/自愿参赛责任书
    handleReportFile(file){
      let url = this.define.previewNginxUrl + file;
      window.open(url);
    },
    // 查看账号密码
    handleViewAccount(userId){
      getUserAccount(userId).then((res) => {
        if (res.code === 200) {
          this.accountInfo = res.data;
          this.accountVisible = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 下载报名表
    handleDownload(userId){
      let url = window.g.VIEW_URL + "/printPdf?id=" + this.competitionId + "&type=2&userId=" + userId;
      window.open(url);
    },
    // 查询代表队详情
    handleDetails(userId){
      this.formVisible = true;
      let params = {
        type: 2,
        competitionId: this.competitionId,
        userId: userId
      }
      competitionSumInfo(params).then((res) => {
        this.competitionSumInfo = res.data;
        this.teamInfoVo = res.data.teamInfoVo;
        this.personStaVo = res.data.personStaVo;
      });
    },
    // 提交（管理员代未提交代表队提交报名）
    handleSubmit(teamId){
      this.$confirm(this.$t('manager.confirmSubmit'), this.$t('common.prompt'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning",
      }).then(() => {
        let params = {
          competitionId: this.competitionId,
          teamId: teamId
        }
        managerSubmitTeamInfo(params).then(res => {
          if (res.code === 200) {
            this.$message.success(res.msg);
            this.findTeamList();
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
      });
    },
    // 退回
    handleCancelSubmit(teamId){
      this.$confirm(this.$t('manager.confirmReject'), this.$t('common.prompt'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning",
      }).then(() => {
        let params = {
          competitionId: this.competitionId,
          teamId: teamId
        }
        cancelSubmitTeamInfo(params).then(res => {
          if (res.code === 200) {
            this.$message.success(res.msg);
            this.findTeamList();
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
      });
    },
    // 删除代表队（级联删除运动员、报项、随队官员）
    handleDelTeam(teamId){
      this.$confirm(this.$t('manager.confirmDelTeam'), this.$t('common.prompt'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning",
      }).then(() => {
        let params = {
          competitionId: this.competitionId,
          teamId: teamId
        }
        managerDelTeamInfo(params).then(res => {
          if (res.code === 200) {
            this.$message.success(res.msg);
            this.findTeamList();
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
      });
    },
    // 退出登录
    logout() {
      this.$confirm(this.$t('manager.confirmLogout'), this.$t('common.prompt'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning",
      }).then(() => {
        logoutApi().finally(() => {
          localStorage.removeItem("token");
          localStorage.removeItem("isRegisterAdmin");
          this.$router.push({path: "/login?id=" + this.competitionId});
        });
      }).catch(() => {
      });
    },
    // 重置
    emptyParams(){
      this.params.teamName = '';
      this.params.mobile = '';
      this.params.status = '';
      this.findTeamList();
    }
  },
};
</script>
<style lang="scss" scoped>

.home {
  width: 100%;
  background-color: #FFFFFF;

  .home-center {
    height: 100vh;

    .header {
      width: 100%;
      height: 120px;
      background-color: #001c58;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .header-name{
        font-size: 30px;
        color: #FFFFFF;
        font-weight: 600;
        margin-left: 30px;
        line-height: 36px;
        letter-spacing: 2px;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);

        div:first-child {
          position: relative;
          padding-left: 14px;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 24px;
            background: #409EFF;
            border-radius: 2px;
          }
        }
      }

      .register-time {
        font-size: 18px;
        background: #83b9f7;
        display: inline-flex;
        align-items: center;
        padding: 6px 18px;
        border-radius: 30px;
        font-weight: bold;
        margin-top: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

        .time-icon {
          color: #fff;
          margin-right: 8px;
          font-size: 18px;
        }
      }

      .header-logo {
        display: flex;

        .logo-img{
          margin: 0 10px;

          img {
            border-radius: 50%;
            width: 100px;
            height: 100px;
          }
        }

        .header-team {
          text-align: right;
          margin-right: 30px;
          display: flex;
          flex-direction: column;
          justify-content: center;

          .team-info {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
          }

          .team-header {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
          }

          .team-icon {
            color: #FFFFFF !important;
            font-size: 20px;
          }

          .username {
            color: rgba(255, 255, 255, 0.75);
            font-size: 14px;
            margin-left: 16px;

            &::before {
              content: '|';
              margin-right: 16px;
              color: rgba(255, 255, 255, 0.3);
            }
          }
        }

        .header-button {
          margin-top: 10px;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          gap: 10px;

          .switch-button {
            margin-right: 8px;
            color: #FFFFFF !important;
          }

          /deep/ .el-button {
            color: #FFFFFF !important;
          }
        }
      }
    }

    .table-center {
      width: 99%;
      height: calc(100vh - 240px);
      margin: 10px auto;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      box-sizing: border-box;

      .search-row {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 16px;
        padding: 16px 20px;
        background: #f8f9fb;
        border-radius: 8px;
        border: 1px solid #e8eaed;
        flex-shrink: 0;

        .search-input {
          width: 200px;
        }
      }

      .table-btn {
        margin-bottom: 10px;
      }

      .table-body {
        flex: 1;
        height: 0;
        min-height: 0;
        overflow: hidden;

        ::v-deep .el-table {
          height: 100%;
        }
      }

      // el-table enhancements
      /deep/ .el-table th.el-table__cell {
        background-color: #f0f2f5;
        color: #303133;
        font-weight: 600;
        padding: 10px 0;
      }

      /deep/ .el-table__body tr:hover > td {
        background-color: #ecf5ff !important;
      }

      /deep/ .el-table__body tr {
        transition: background-color 0.2s;
      }

      // Status badge pills
      .status-badge {
        display: inline-block;
        padding: 4px 14px;
        border-radius: 20px;
        font-size: 13px;
        font-weight: 500;
        line-height: 1.4;

        &.status-not-submitted {
          background: #f0f2f5;
          color: #909399;
        }

        &.status-submitted {
          background: #e1f3d8;
          color: #67c23a;
        }
      }
    }

    .el-header {
      border-bottom: #edf1f6 solid 1px;
      color: #333;
      padding: 0;
    }

    .el-aside {
      color: #333;
      text-align: left;
    }

    .el-main {
      border-left: #edf1f6 solid 1px;
      height: calc(100vh - 180px);
      padding: 20px;
    }

    .el-footer {
      border-top: #edf1f6 solid 1px;
      border-left: #edf1f6 solid 1px;
      color: #333;
    }
  }
}

// Detail dialog styles
.table-info {

  .row-border-1 {
    display: flex;
    // 列拉伸到整行高，竖向边框才不会被换行撑高的行截短；列内用flex保持内容垂直居中
    align-items: stretch;
    flex-wrap: wrap;
    border-top: 1px solid #dcdcdc;
    border-left: 1px solid #dcdcdc;
    border-right: 1px solid #dcdcdc;
    transition: background-color 0.15s;

    > .el-col {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  .cell-border-f {
    border-left: 1px solid #dcdcdc;
    box-sizing: border-box;
  }

  .cell-border-fb {
    border-left: 1px solid #dcdcdc;
    border-bottom: 1px solid #dcdcdc;
    box-sizing: border-box;
  }

  .cell-border-b {
    border-bottom: 1px solid #dcdcdc;
    box-sizing: border-box;
  }

  .text-center{
    text-align: center;
  }

  .font-weight {
    font-weight: bold;
    color: #303133;
  }

  .word-break{
    word-break: break-all;
  }

  .cell-image{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    word-break: break-all;
  }

  .padding10 {
    padding: 10px;
  }

  .bg-eeecec {
    background: #f0f2f5;
    padding: 12px 10px;
    border-left: 4px solid #409eff;
  }
}

// Dialog enhancements
.el-dialog {
  .el-dialog__body {
    padding: 20px 30px;
  }
}
</style>
